<template>
  <div class="icon-box" :style="`background-color: ${backgroundColor};`">
    <icon class="icon-box__icon" :name="name" :variant="variant"></icon>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'IconBox',
  components: { Icon },
  props: {
    name: {
      type: String,
      default: 'cross',
    },
    variant: {
      type: String,
      default: 'ffffff',
    },
    backgroundColor: {
      type: String,
      default: 'black',
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-box {
  width: rem-calc(55);
  height: rem-calc(55);
  border-radius: 25%;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-box__icon {
    height: rem-calc(14);
    width: rem-calc(14);
  }
}

@media (min-width: 1201px) {
  .icon-box {
    width: rem-calc(32);
    height: rem-calc(32);
  }

  .icon-box__icon {
    height: rem-calc(18);
    width: rem-calc(18);
  }
}
</style>
